import { React, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import ComplianceWorkspace from "./pages/ComplianceWorkspace";
import Locations from "./pages/Master/Locations";
import TaskTemplates from "./pages/Master/TaskTemplates";
import Compliances from "./pages/Master/Compliances";
import ComplianceTypes from "./pages/Master/ComplianceTypes";
import MasterRegistry from "./pages/Master/MasterRegistry";
import Redirect from "./pages/Redirect";
import Logout from "./pages/Logout";
import Footer from "./pages/Footer";
import { useAuth } from "./pages/AuthContext";
import Navbar from "./pages/Navigation";
import MainLayout from "./layouts/MainLayout";
import { appUrl, appName } from "./pages/app_props";
import RegulationsPage from "./pages/RegulationsPage";
import RequirementsPage from "./pages/RequirementsPage";
import StandardsPage from "./pages/StandardsPage";
import TasksPage from "./pages/TasksPage";

const routes = [
  {
    path: "/",
    element: <Redirect />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/regulations/*",
    element: <RegulationsPage />,
  },
  {
    path: "/requirements/*",
    element: <RequirementsPage />,
  },
  {
    path: "/standards/*",
    element: <StandardsPage />,
  },
  {
    path: "/tasks/*",
    element: <TasksPage />,
  },
  {
    path: "/master/locations",
    element: <Locations />,
  },
  {
    path: "/master/compliances",
    element: <Compliances />,
  },
  {
    path: "/master/compliance-types",
    element: <ComplianceTypes />,
  },
  {
    path: "/master/task-templates",
    element: <TaskTemplates />,
  },
  {
    path: "/master/master-registry",
    element: <MasterRegistry />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
];

const RouteConfig = () => {
  const { user } = useAuth();

  // const { user } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if the user is available
    if (user) {
      if (user.authorities !== undefined) {
        if (user.authorities.length > 0) {
          sessionStorage.setItem("userInfo", JSON.stringify(user));
          setLoading(true);
        } else {
          setLoading(false);
        }
      }
    }
  }, []);

  if (!loading) {
    // If user or user.authority is not present, do not render Navbar
    return (
      <BrowserRouter
        basename={
          !appUrl.endsWith("vistaarintuitivesolution.com")
            ? "/" + appName
            : undefined
        }
      >
        {/* <Navbar /> */}
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
          <Route path="/authorized" element={<Redirect />} />
        </Routes>
      </BrowserRouter>
    );
  }
  return (
    <BrowserRouter
      basename={
        !appUrl.endsWith("vistaarintuitivesolution.com")
          ? "/" + appName
          : undefined
      }
    >
      <Navbar />
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
        <Route path="/authorized" element={<Redirect />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default RouteConfig;
